import React from 'react';
import styled, { useTheme } from 'styled-components';
import Loader from 'react-loading';

import { currencyNumberFormat } from '../../../utilities/number-format';

interface Props {
  value: number;
  loading: boolean;
}

const TotalBalance = ({ value, loading }: Props) => {
  const theme = useTheme();

  return (
    <Box>
      <Text>Total Balance</Text>
      {loading ? (
        <LoaderHolder>
          <Loader type="spin" color={theme.colors.KBYellow} height={24} width={24} />
        </LoaderHolder>
      ) : (
        <Value>{currencyNumberFormat(value)}</Value>
      )}
    </Box>
  );
};

export default TotalBalance;

const Box = styled.div`
  width: 100%;
  padding: 7px 0px 10px 0px;
  margin-top: 20px;

  border: 1px solid ${({ theme }) => theme.colors.beige};

  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.night};
  text-align: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    width: 190px;
    text-align: start;
    padding: 20px 32px;
  }
`;

const Text = styled.span`
  display: block;
  font-size: 12px;
  line-height: 24px;
  text-transform: uppercase;
  font-weight: 600;
`;

const Value = styled.span`
  display: block;
  font-size: 23px;
  font-weight: 600;
  line-height: 29px;
`;

const LoaderHolder = styled.div`
  display: flex;
  justify-content: center;
`;
